class User {
  constructor(attributes) {
    this.currentEmail = attributes.current_email
    this.emails = attributes.emails
    this.slug = attributes.slug
  }
}

export default User
